<template>
  <lu-vbox class='app-container svpad-in-20' lu-flex>
    <Spinner ref='spinner' />

    <lu-hbox>
      <PageHeader :title='headTitle' :hasList='true' :hasReload='true' :hasPrev='hasPrev' :hasNext='hasNext' @prev='goPrev' @next='goNext' @back='back' @reload='reload' >
        <lu-hbox slot='extraArea' class='pad-in-5' >
          <template v-if='isEdit'>
            <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='saveAdmin'>{{ $t('action.save') }}</el-button></lu-item>
            <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancelAdmin'>{{ $t('action.cancel') }}</el-button></lu-item>
          </template>
          <template v-if='!isReadOnly'>
            <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='save'>{{ $t('action.save') }}</el-button></lu-item>
            <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancel'>{{ $t('action.cancel') }}</el-button></lu-item>
          </template>
          <template v-else-if='$acl.isAllowed("adminBrokerEdit")'>
            <lu-item><el-button class="button" icon="el-icon-edit" @click.stop='edit' >{{ $t('action.edit') }}</el-button></lu-item>
            <lu-item><el-button class="button" icon="el-icon-delete" v-if='form.isUsed === 0' @click.stop='handleDelete(form)' >{{ $t('action.delete') }}</el-button></lu-item>
          </template>
        </lu-hbox>
      </PageHeader>
    </lu-hbox>

    <lu-vbox lu-flex >

      <el-form ref='form' :model='form' lu-flex label-width="200px" :rules="dynamicRules">

        <lu-vbox  class='sectionBox' lu-vcenter lu-flex-wrap style='margin-top: 10px'>

          <PageTitle :title='$t("Broker Environments")' @togglePageTitle='togglePageTitle' />

          <lu-hbox>

            <el-form-item label="Platform Short Name" prop="shortName">
              <el-input v-model='form.shortName' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>

            <el-form-item label="Platform Long Name" prop="brokerLongName">
              <el-input v-model='form.brokerLongName' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>

            <el-form-item label="Status" prop="status" >
              <el-switch v-model='form.status' :disabled='isReadOnly' :readonly='isReadOnly'
                :active-value='1'
                :inactive-value='0'
                :active-text="$t('active')"
                :inactive-text="$t('Inactive')"
              />
            </el-form-item>
          </lu-hbox>
        </lu-vbox>

<!--
            <template v-if='!this.$route.params.create'>
              <el-form-item label="Create User" prop="createUserName">
                <el-input v-model='form.createUserName' readonly />
              </el-form-item>

              <el-form-item label="Create Date" prop="createDate">
                <el-input v-model='form.createDate' readonly/>
              </el-form-item>

              <el-form-item label="Update user" prop="updateUserName">
                <el-input v-model='form.updateUserName' readonly />
              </el-form-item>

              <el-form-item label="Update date" prop="updateDate">
                <el-input v-model='form.updateDate' readonly />
              </el-form-item>
            </template>

-->

        <lu-vbox  class='sectionBox' lu-vcenter lu-flex-wrap style='margin-top: 10px'>

          <PageTitle :title='$t("Platforms")' @togglePageTitle='togglePageTitle' >
              <lu-item slot='extraArea'><el-button class="button" icon="el-icon-check"  @click.stop='newPlatForm'>{{ $t('new platForm') }}</el-button></lu-item>
          </PageTitle>

          <el-table
              class='table'
              ref='table'
              :data="form.brokerList"
              fit
              striped
              highlight-current-row
              style="width: 100%;margin-top:20px;"
              :row-class-name="tableRowClassName"
            >

              <el-table-column :label="$t('PTF ID')" prop="brokerPtfId" sortable align="center" swidth="65" >
                <template slot-scope="{row}">
                  <span>{{ row.brokerPtfId }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('Label')" sortable prop='brokerPtfName' align="center">
                <template slot-scope="{row}">
                  <span >{{ row.brokerPtfName  }}</span>
                </template>
              </el-table-column>

             <el-table-column :label="$t('Price addr')" sortable prop='bpiPriceAddress' align="center">
                <template slot-scope="{row}">
                  <span>{{ row.bpiPriceAddress }} : {{ row.bpiPricePort }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('Trade Addr')" sortable prop='bpiTradeAddress' align="center">
                <template slot-scope="{row}">
                  <span>{{ row.bpiTradeAddress }} : {{ row.bpiTradePort }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('Update Date')" sortable prop='updateDate' align="center">
                <template slot-scope="{row}">
                  <span>{{ row.updateDate }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('Status')" sortable prop='status' align='center' >
                <template slot-scope="{row}">
                    <el-tag style='width:100px;' size="mini" :type="row.status | statusFilter" >
                      <i :class="statusActiveName(row.status)" style='margin-right: 5px;' />
                        {{ row.status | statusLabel }}
                    </el-tag>
                </template>
              </el-table-column>

              <el-table-column :label="$t('Actions')" align="center" width="150" class-name="small-padding fixed-width">
                <template slot-scope="{row}">
                  <lu-hbox lsu-hcenter slu-vcenter cslass='pad-in-5'>
                    <el-button size="mini" class='icon' :icon="$acl.isAllowed('adminBrokerEdit') ? 'el-icon-edit success' : 'el-icon-view success'"  @click='handleEdit(row)'/>
                    <el-button size="mini" class='icon' icon="el-icon-delete error"  @click='del(row)' v-if='row.isUsed === 0 && $acl.isAllowed("adminBrokerEdit")'/>
                  </lu-hbox>
                </template>

              </el-table-column>
            </el-table>
          </lu-vbox>


        <lu-vbox v-if='selectedPtf' class='sectionBox' lu-vcenter lu-flex-wrap style='margin-top: 10px'>

          <PageTitle :title='detailTitle' @togglePageTitle='togglePageTitle' >
            <lu-hbox v-if='!selectedPtf.brokerPtfId' slot='extraArea' class='pad-in-5'>
              <!-- <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='savePlatform'>{{ $t('action.add') }}</el-button></lu-item> -->
              <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancelPlatform'>{{ $t('action.cancel') }}</el-button></lu-item>
            </lu-hbox>
          </PageTitle>

          <lu-hbox sclass='sectionBox' lu-vcenter lu-flex-wrap style='margin-top: 10px'>
            <el-form-item label="Broker Short Name" :prop="'brokerList[' + selectedIdx + '].shortName'" :rules='brokerPtfNameRules'>
              <el-input v-model='selectedPtf.shortName' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>

            <el-form-item label="Broker Long Name" :prop="'brokerList[' + selectedIdx + '].brokerPtfName'" :rules='brokerPtfNameRules'>
              <el-input v-model='selectedPtf.brokerPtfName' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>

            <el-form-item label="Price address" :prop="'brokerList[' + selectedIdx + '].bpiPriceAddress'">
              <el-input v-model='selectedPtf.bpiPriceAddress' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>

            <el-form-item label="Price port" :prop="'brokerList[' + selectedIdx + '].bpiPricePort'">
              <el-input v-model='selectedPtf.bpiPricePort' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>

            <el-form-item label="Trade address" :prop="'brokerList[' + selectedIdx + '].bpiTradeAddress'">
              <el-input v-model='selectedPtf.bpiTradeAddress' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>

            <el-form-item label="Trade port" :prop="'brokerList[' + selectedIdx + '].bpiTradePort'">
              <el-input v-model='selectedPtf.bpiTradePort' :disabled='isReadOnly' :readonly='isReadOnly'/>
            </el-form-item>

            <el-form-item label="Status" :prop="'brokerList[' + selectedIdx + '].status'" >
              <el-switch v-model='selectedPtf.status' :disabled='isReadOnly' :readonly='isReadOnly'
                :active-value='1'
                :inactive-value='0'
                :active-text="$t('active')"
                :inactive-text="$t('Inactive')"
              />
            </el-form-item>

            <template sv-if='!this.$route.params.create' v-if='selectedPtf.brokerPtfId'>
              <el-form-item label="Create User" :prop="'brokerList[' + selectedIdx + '].createUserName'">
                <el-input v-model='selectedPtf.createUserName' readonly />
              </el-form-item>

              <el-form-item label="Create Date" :prop="'brokerList[' + selectedIdx + '].createDate'">
                <el-input v-model='selectedPtf.createDate' readonly/>
              </el-form-item>

              <el-form-item label="Update user" :prop="'brokerList[' + selectedIdx + '].updateUserName'">
                <el-input v-model='selectedPtf.updateUserName' readonly />
              </el-form-item>

              <el-form-item label="Update date" :prop="'brokerList[' + selectedIdx + '].updateDate'">
                <el-input v-model='selectedPtf.updateDate' readonly />
              </el-form-item>
            </template>
          </lu-hbox>
        </lu-vbox>

      </el-form>

  </lu-vbox>

  </lu-vbox>
</template>

<script>
import FormController from '@/controllers/FormController'
import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'
import PageTitle from '@/components/PageTitle'
import Spinner from '@/components/Spinner'
import { mapGetters } from 'vuex'
import Debouncer from '@/utils/debounce.js'
import brokerMixin from './mixin'

export default {
  name: 'adminBrokerEdit',
  extends: FormController,
  mixins: [ brokerMixin ],
  components: { LuVbox, LuHbox, LuItem, PageHeader, PageTitle, Spinner },
  filters: {
    statusLabel(status) {
      return status === 1 ? 'Active' : 'Inactive'
    },
    statusFilter(status) {
      return status === 1 ? 'success' : 'warning'
    },
    upperCase(str) {
      return str.toUpperCase()
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    pageControllerName: function () {
      return 'adminBrokerEdit'
    },
    togglePageTitle: function () {

    },
    toggleEnv: function (env) {
      if (!this.isReadOnly) {
        env.isAllowed = !env.isAllowed
      }
    },
    paramControllerName: function () {
      return 'adminBrokerEdit'
    },
    getDefaultOrder: function () {
      return 'label ASC'
    },
    saveAdmin: function () {
      this.isEdit = false
    },
    newPlatForm () {
      if (this.isNew) return
      this.isNew = true
      this.isReadOnly = false
      this.selectedPtf = {
        brokerId: this.form.brokerId,
        brokerPtfId: undefined,
        shortName: '',
        brokerPtfName: undefined,
        bpiPriceAddress: undefined,
        bpiPricePort: undefined,
        bpiTradeAddress: undefined,
        bpiTradePort: undefined,
        status: 0,
        isUsed: 0
      }
      this.form.brokerList.push(this.selectedPtf)
      this.selectedIdx = this.form.brokerList.length - 1
    },
    savePlatform () {

    },
    del (row) {
      if (row.brokerPtfId) {
        this.handleDelete(row)
      }
      else {
        this.cancelPlatform()
      }
    },
    cancelPlatform () {
      this.form.brokerList.splice(this.selectedIdx, 1)
      this.isNew = false
      this.selectedPtf = null
      this.selectedIdx = null
    },
    handleEdit(row) {
      let idx = this.form.brokerList.findIndex(b => b.brokerPtfId === row.brokerPtfId)
      if (idx !== -1) {
        this.selectedPtf = this.form.brokerList[idx]
        this.selectedIdx = idx
      }
    },
    reload () {
      this.selectedPtf = null
      this.$nextTick().then(() => {
        this.isReadOnly = true
        this.isNew = false
        this.selectedPtf = null
        this.selectedIdx = null
        this.forceReload = !this.forceReload
      })
    },
    cancel () {
      if (this.$route.params.create) {
        this.returnPage()
      }
      else {
        this.selectedPtf = null
        this.$nextTick().then(() => { this.isReadOnly = true; this.reload() })
      }
    },
    cancelAdmin () {
      this.isEdit = false
      this.reload()
    },
    edit: function () {
      this.isReadOnly = false
    },
    editAdmin: function () {
      this.isEdit = true
    },
    back: function () {
      this.returnPage()
    },
    getRecord: function () {
      this.isReadOnly = true
      this.createFormData1()
      return this.fetchRecord('readBroker', {
        indDetail: 1,
        conditions: [ { 'field name': 'brokerId', operator: '=', value: [ this.$route.params.recordId ] } ]
      }, 'brokerList', true).then(rep => {
        rep.forEach(item => {
          this.form.brokerId = item.brokerId
          this.form.shortName = item.brokerShortName
          this.form.brokerLongName = item.brokerLongName
          this.form.status = item.brokerStatus
          if (item.brokerPtfId) {
            this.form.brokerList.push(Object.assign({
              brokerPtfId: item.brokerPtfId,
              brokerId: item.brokerId,
              brokerShortName: item.brokerPtfName,
              brokerName: item.brokerShortName,
              status: item.status,
              isUsed: item.isUsed,
              isEdit: false
            }, item))
          }
        })
      })
    },
    createFormData1: function () {
      this.initFormField(this.form, 'brokerId', null)
      this.initFormField(this.form, 'shortName', '')
      this.initFormField(this.form, 'brokerLongName', '')
      this.initFormField(this.form, 'createUserId', null)
      this.initFormField(this.form, 'createDate', '')
      this.initFormField(this.form, 'updateUserId', null)
      this.initFormField(this.form, 'updateDate', '')
      this.initFormField(this.form, 'isUsed', 0)
      this.initFormField(this.form, 'status', false)
      this.initFormField(this.form, 'createUserName', '')
      this.initFormField(this.form, 'updateUserName', '')
      this.initFormField(this.form, 'brokerList', [])
    },
    statusActiveName (type) {
      if (type === 1) return 'el-icon-success'
      else return 'el-icon-check'
    }
  },
  computed: {
    ...mapGetters([ 'isAdmin', 'userInfos' ]),
    detailTitle () {
      if (this.selectedPtf.brokerPtfId) {
        return this.$t('Detail platform')
      }
      else {
        return this.$t('New platform')
      }
    },
    dynamicRules: function () {
      return this.isReadOnly ? {} : this.rules
    },
    headTitle: function () {
      let title = this.$t('Create') + ' ' + this.name
      if (!this.$route.params.create) {
        title = ((this.isReadOnly) ? this.name : this.$t('Edit')) + ' : '
        title += this.form.shortName
      }
      return title
    },
    isCollapsedOrNot: function () {
      return this.isReadOnly
    },
    param: function () {
      return this.$route.params
    },
    requiredMessage: function () {
      return this.isReadOnly ? null : this.$t('This field is required')
    },
    recordLabel: function () {
      return this.form.label
    }
  },
  data () {
    return {
      isEdit: false,
      isNew: false,
      selectedPtf: null,
      selectedIdx: null,
      debouncer1: new Debouncer(),
      debouncer2: new Debouncer(),
      isReadOnly: (!this.$route.params.create) ? this.$route.params.isReadOnly : false,
      expanded: {},
      nodeId: 0,
      name: this.$t('Broker'),
      form: {
        status: false,
        brokerId: undefined,
        brokerShortName: undefined,
        brokerLongName: undefined,
        createUserId: undefined,
        createDate: undefined,
        updateUserId: undefined,
        updateDate: undefined,
        isUsed: undefined,
        brokerList: [],
        children: []
      },
      rules: {
        brokerShortName: [
          { required: true, message: this.$t('Please input short name'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 3 characters.'), trigger: ['blur', 'change'] },
          { validator: this.checkBrokerName }
        ],
        brokerLongName: [
          { required: true, message: this.$t('Please input Long name'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 3 characters.'), trigger: ['blur', 'change'] },
          { validator: this.checkBrokerLongName }
        ]
      },
      brokerPtfNameRules: [
        { required: true, message: this.$t('Please input platform long name'), trigger: ['blur', 'change'] },
        { min: 3, message: this.$t('Minimum length should be at least 3 characters.'), trigger: ['blur', 'change'] }
        // { validator: this.checkBrokerLongName }
      ]
    }
  }
}
</script>

<style scoped>

</style>
